import {
    SET_SKILLS_VIDEOS,
    SET_NO_VIDEO_MESSAGE,
    HIDE_VIDEO_MESSAGE,
    SET_HELP_VIDEOS,
    SET_SKILLS_ASSESSMENTS,
    SET_SKILLS_ASSESSMENTS_ERRORS,
    FETCH_SKILL_TYPES,
    SET_CERTIFICATIONS
} from "../actions/types";

export default function (state = {}, action) {
    switch (action.type) {
        case SET_SKILLS_VIDEOS: {
            if (state.skill_videos){
                return {
                    ...state,
                    skill_videos: { ...state.skill_videos, [action.skillName]: action.videos }
                }
            } else {
                let video = action.videos;
                let obj = {};
                obj[action.skillName] = video;
            
                return {
                    ...state,
                    skill_videos: obj
                }
            }
        }
        case SET_NO_VIDEO_MESSAGE: {
            let message = `No resources has been found for ${action.skillName}`;
            return {
                ...state,
                skill_notification: message
            }
        }
        case HIDE_VIDEO_MESSAGE: {
            return {
                ...state,
                skill_notification: false
            }
        }
        case SET_HELP_VIDEOS:{
            return {
                ...state,
                authenticatedVideos: action.data
            }
        }
        case SET_SKILLS_ASSESSMENTS: {
            return {
                ...state,
                skillAssessment: action.data
            }
        }
        case SET_SKILLS_ASSESSMENTS_ERRORS: {
            return {
                ...state,
                skillAssessmentErrors: state.skillAssessmentErrors ? [...state.skillAssessmentErrors, ...action.data] : action.data
            }
        }
        case FETCH_SKILL_TYPES:{
            const oldTypes = state.skillTypesMap ? state.skillTypesMap : {}
            return {
                ...state, 
                skillTypesMap: {...oldTypes,...action.data}
            }
        }
        case SET_CERTIFICATIONS:{
            return {
                ...state,
                certifications: action.data.map((item) => {
                    return {
                        ...item,
                    }
                })
            }
        }
        default: return state;
    }
}